/* import __COLOCATED_TEMPLATE__ from './team-select-item.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();